import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function Orderlist({ result, clearSearch }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        marginTop: "5px",
      }}
    >
      <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
        Orders {result.orders?.length > 0 && `(${result.orders.length})`}
      </Typography>
      <Box
        sx={{
          marginTop: "5px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {result.orders?.length > 0 ? (
          result.orders.map((obj, i) => {
            return (
              <Box
                key={i}
                onClick={() => {
                  navigate(`/order-detail`, { state: { selectedOrder: obj } });
                  clearSearch();
                }}
                sx={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#673C8E0F",
                  fontWeight: 700,
                  color: "black",
                  "&:active": {
                    backgroundColor: "#ddd0e9", // new background on hover
                  },
                }}
              >
                {obj.orderId}
              </Box>
            );
          })
        ) : (
          <Typography
            sx={{ fontWeight: 700, fontSize: "14px", color: "black" }}
          >
            No Results
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default Orderlist;
